import React from "react";

import { useLoginContext } from "../../context/loginContext";

import { genderMaleFemaleUngenderd, sqlDateToHumanDate, getPropInSubLevelRole, safeValue } from "../../utils/globalFunctions";
import { canAccessSeeCustomersPhoneNumber } from "../../utils/accessing";

import LabelContentInline from "../../components/general/LabelContentInline";

const CustomerData = ({ stateData }) => {

    const { loginContext } = useLoginContext();

    return (
        <React.Fragment>
            <LabelContentInline
                stateColLabel={4}
                stateLabel='Nama'
                stateContent={stateData.customer_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Gender'
                stateContent={genderMaleFemaleUngenderd(stateData.customer_gender, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Kategori'
                stateContent={stateData.customer_category_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Group'
                stateContent={stateData.customer_group_name}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Id Card'
                stateContent={stateData.customer_id_card_number}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Alamat'
                stateContent={stateData.customer_address}
                stateDivider={true}
            />

            {canAccessSeeCustomersPhoneNumber({ stateObject: { subLevel: loginContext } }) &&
                <LabelContentInline
                    stateColLabel={4}
                    stateLabel='Kontak'
                    stateContent={safeValue(stateData.customer_contact, '-')}
                    stateDivider={true}
                />
            }

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Keterangan'
                stateContent={stateData.customer_info ? stateData.customer_info : '-'}
                stateContentIsPreLine={true}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Status'
                stateContent={stateData.customer_is_active === '1' ? 'Aktif' : 'Non Aktif'}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Tanggal Input'
                stateContent={sqlDateToHumanDate({
                    stateDate: stateData.customer_created_datetime,
                    stateWithTime: true,
                    stateLang: 'id',
                    stateIsShort: false,
                    stateDay: false,
                    stateDefaultValue: ' - ',
                    stateDateType: 'day'
                })}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Diinput Oleh'
                stateContent={safeValue(stateData.customer_created_user_name, '-')}
                stateDivider={true}
            />

            <LabelContentInline
                stateColLabel={4}
                stateLabel='Jabatan'
                stateContent={getPropInSubLevelRole(stateData.customer_created_user_sub_level, 'caption', '-')}
                stateDivider={false}
            />
        </React.Fragment>
    )
}

export default CustomerData;